import React from 'react';
import { useIntl } from 'react-intl';

const CustomTextarea = ({
  placeholder,
  name,
  value,
  label,
  error,
  register,
  required,
  change,
  customClass,
  customClassLabel = '',
  classTextarea = '',
  showErrorMessage = true,
  classError,
  description,
  tooltip,
  disabled = false,
  rows = '',
}) => {
  const defaultValue = value || '';
  const translate = useIntl();
  const changeError = (typeError) => {
    if (typeError === 'required') {
      return translate.formatMessage({ id: 'acc.field-required' });
    }
    if (typeError === 'maxLength') {
      return translate.formatMessage({ id: 'acc.long-required' });
    }
    return '';
  };

  const customLabelClass = `${required ? 'required' : ''} wizard__label ${customClassLabel}`;
  const classInput = `${error ? `error ${classError}` : ''} ${classTextarea} ${description ? 'wizard__textarea-with-desc' : ''}`;
  const classWrapper = `wizard__textarea ${customClass}`;

  return (
    <div className={classWrapper}>
      {label && (
        <label className={customLabelClass}>
          {label}
          {tooltip}
        </label>
      )}
      {description && <span className="wizard__secondary-txt">{description}</span>}
      <textarea
        placeholder={placeholder}
        name={name}
        defaultValue={defaultValue}
        ref={register}
        className={classInput}
        onChange={change}
        onWheel={(ev) => ev.target.blur()}
        disabled={disabled}
        rows={rows}
      />
      {error && showErrorMessage && <div className="input__error wizard__textarea-error">{changeError(error.type)}</div>}
    </div>
  );
};

export default CustomTextarea;
